module.exports = __webpack_public_path__ + "static/media/ico-add.579b6b11.svg";